import React from 'react';
import styles from './promo-card-row.module.scss';
import PromoCard from '../../atoms/promo-card/promo-card';
import PromoRow from '../../../models/promo/PromoRow';

export default function PromoCardRow({ promoApp, config }: PromoRow) {
  const partsCount = config.reduce((a, b) => a + b, 0);

  return (
    <div className={`${styles['promo-row']} row`}>
      {promoApp &&
        promoApp.map((el, i) => (
          <div key={el.id} className={`col-xl-${(12 / partsCount) * config[i]}`}>
            <PromoCard cardContent={el} isOneThird={config.length === 2 && config[i] === 1} />
          </div>
        ))}
    </div>
  );
}
